import type {CreateSupplierFormPayload} from "./create-supplier.schema";
import type {CreateSupplierRequest} from "@project/sdk/engineering";

export const createSupplierMapper = {
  toSdk(payload: CreateSupplierFormPayload): CreateSupplierRequest {
    return {
      company: {
        companyId: payload.companyId,
        companyName: payload.companyName,
        partyProfile: {
          address: {address: payload.address},
          country: payload.country,
          phone: {regionCode: payload.phonePrefix, nationalNumber: payload.phoneNumber},
          ...(payload.websiteUrl === undefined ? {} : {websiteUrl: payload.websiteUrl}),
        },
      },
      ...(payload.logoUrl === undefined ? {} : {logoUrl: payload.logoUrl}),
      status: payload.status,
      roles: payload.roles,
      standardization: payload.standardization,
      deliveryTimeDays: payload.deliveryTimeDays,
      paymentTimeDays: payload.paymentTimeDays,
    };
  },
};
